import {RoleType} from '@drl/core/enums';
import {ChatMessage} from './chat-message.model';

export class ChatNotification {
  id?: string;
  messageId: string;
  recipientId?: number;
  roleKey?: RoleType;
  isRead: boolean;
  message?: ChatMessage;
  createdOn?: Date;
  notificationTime?: string;
  messageTitle?: string;
  messageBody?: string;
}
